export default function roundedRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r:
    | number
    | {
    lb: number
    lt: number
    rb: number
    rt: number
  },
  stroke = false,
) {
  if (typeof r == 'number') {
    if (w < 2 * r) r = w / 2
    if (h < 2 * r) r = h / 2
    r = {
      lb: r,
      lt: r,
      rb: r,
      rt: r,
    }
  }
  ctx.beginPath()
  ctx.moveTo(x + r.rt, y)
  ctx.arcTo(x + w, y, x + w, y + h, r.rt)
  ctx.arcTo(x + w, y + h, x, y + h, r.rb)
  ctx.arcTo(x, y + h, x, y, r.lb)
  ctx.arcTo(x, y, x + w, y, r.lt)
  ctx.closePath()
  ctx.fill()
  if (stroke) {
    ctx.stroke()
  }
}
